import { Component, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { ModalService } from '../../../common/services/modal.service';
import { AccountApiService } from '../../../services/account.api.service';
import { AlertifyService } from '../../../services/alertify.service';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { ButtonTriggerEvent } from '../../../common/components';
import { ShowInfoModalComponent } from '../../hub/show.info.modal/show.info.modal.component';
import {
  InfoModalData,
  ShowInfoModalActions,
} from '../../hub/show.info.modal/show.info.modal.provider';
import {
  AddEventbriteEventsModalActions,
  AddEventbriteEventsModalData,
} from './add.eventbrite.events.modal.provider';
@Component({
  templateUrl: './add.eventbrite.events.modal.component.html',
  styleUrls: ['./add.eventbrite.events.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddEventbriteEvenetsModalComponent extends BaseComponent {
  public data: AddEventbriteEventsModalData;
  public isApproved = true;
  public totalEvents = 0;
  public isSaving = false;
  @ViewChild('div') public div: ElementRef;

  constructor(
    private dialogRef: MatDialogRef<AddEventbriteEvenetsModalComponent>,
    private actions: AddEventbriteEventsModalActions,
    public imageService: ImageService,
    private alertify: AlertifyService,
    private accountApiService: AccountApiService,
    private modalService: ModalService,
    data: AddEventbriteEventsModalData
  ) {
    super();
    this.data = data;
    this.data.events.forEach((x) => {
      x.checked = true;
    });
    this.totalEvents = this.data.events.length;
  }

  public toggleAll() {
    this.data.events.forEach((e) => {
      e.checked = !e.checked;
    });
  }

  public close(): void {
    this.dialogRef.close();
  }

  public async confirm(event: ButtonTriggerEvent) {
    let events: any[] = this.data.events.filter((x) => x.checked);
    if (events.length === 0) {
      event.complete();
      this.alertify.warning('No event selected');
      return;
    }
    events.forEach((x) => {
      delete x.checked;
    });
    this.isSaving = true;
    this.accountApiService
      .savePulledEventbriteEvents(this.data.account._id, events, this.isApproved)
      .finally(() => {
        event.complete();
        this.isSaving = false;
      })
      .subscribe((result) => {
        if (result) {
          if (result.saved.length === this.totalEvents) {
            this.alertify.successfully('Save events');
            this.actions.confirm(event);
            this.close();
          } else {
            let icons = [],
              text = [];
            if (result.saved.length) {
              icons.push({ icon: 'check', color: 'green' });
              text.push(`${result.saved.length} events saved successfully`);
            }
            if (result.updated.length) {
              icons.push({ icon: 'cached', color: 'green' });
              text.push(`${result.updated.length} events updated`);
            }
            if (result.merged.length) {
              icons.push({ icon: 'list', color: 'green' });
              text.push(`${result.merged.length} events merged`);
            }
            if (result.existed.length) {
              icons.push({ icon: 'error_outline', color: 'orange' });
              text.push(`${result.existed.length} events not saved due to existed`);
            }
            if (result.notSaved.length) {
              icons.push({ icon: 'error_outline', color: 'red' });
              text.push(
                `${result.notSaved.length} events not saved due to missing properties, please check event info and address`
              );
            }
            if (result.approvalStatusNotChanged.length) {
              text.push(`<hr style="width:680px;height:unset"/>`);
              text.push(
                `<span style="margin-bottom: 6px">The following events already exist and ${
                  this.isApproved
                    ? '<span style="color:red">unapproved</span>'
                    : '<span style="color:green">approved</span>'
                }, they will stay ${
                  this.isApproved
                    ? '<span style="color:red">unapproved.</span>'
                    : '<span style="color:green">approved.</span>'
                }</span>`
              );
              result.approvalStatusNotChanged.forEach((x, i) => {
                text.push(`<span style="font-size: 14px">${i + 1}: ${x}</span>`);
              });
            }
            this.modalService.show({
              component: ShowInfoModalComponent,
              providers: [
                { provide: ShowInfoModalActions, useValue: null },
                {
                  provide: InfoModalData,
                  useValue: new InfoModalData('Result', icons, text),
                },
              ],
              panelClass: 'width-modal-3',
            });
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/add.eventbrite.events.modal/add.eventbrite.events.modal.component.ts